<template>
	<div class="overview-text">
		<div class="layout1" v-if="item.layout==1">
			<p v-html="item.content"></p>
		</div>
		<div class="layout-txt2" v-if="item.layout==2">
			<div class="layout-txt-list" v-html="item.content"
				:style="`width:${item.oneRatio}%`" v-if="item.oneRatio>0">
			</div>
			<div class="layout-txt-list" v-html="item.twoContent"
				:style="`width:${item.twoRatio}%`" v-if="item.twoRatio>0">
			</div>
		</div>
		<div class="layout-txt3" v-if="item.layout==3">
			<div class="layout-txt-list" v-html="item.content"
				:style="`width:${item.oneRatio}%`" v-if="item.oneRatio>0">
			</div>
			<div class="layout-txt-list" v-html="item.twoContent"
				:style="`width:${item.twoRatio}%`" v-if="item.twoRatio>0">
			</div>
			<div class="layout-txt-list" v-html="item.threeContent"
				:style="`width:${item.threeRatio}%`" v-if="item.threeRatio>0">
			</div>
		</div>
		<div class="layout-txt4" v-if="item.layout==4">
			<div class="layout-txt-list" v-html="item.content"
				:style="`width:${item.oneRatio}%`" v-if="item.oneRatio>0">
			</div>
			<div class="layout-txt-list" v-html="item.twoContent"
				:style="`width:${item.twoRatio}%`" v-if="item.twoRatio>0">
			</div>
			<div class="layout-txt-list" v-html="item.threeContent"
				:style="`width:${item.threeRatio}%`" v-if="item.threeRatio>0">
			</div>
			<div class="layout-txt-list" v-html="item.fourContent"
				:style="`width:${item.fourRatio}%`" v-if="item.fourRatio>0">
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	export default {
		name: 'ProductColumns',
		props: {
			item: {
				type: Object,
				value: {}
			}
		},
		data(){
			return{
				
			}
		},
		created(){
			
		},
		methods: {
			
		}
	}
</script>

<style scoped lang="less">
	.overview-text{
		width: 100%;
		.layout1{
			
		}
		.layout-txt2,.layout-txt3, .layout-txt4 {
			display: flex;
			justify-content: flex-start;
			box-sizing: border-box;	
		}
		.layout-txt-list {
			margin-right: 15px;
			box-sizing: border-box;
			word-break: break-all;
			word-wrap: break-word;
			overflow: hidden;
		}
				
		.layout-txt-list:last-of-type {
			margin-right: 0;
		}
	}
</style>